import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PluginConfig {
    plugins: any[] = [];
}

